import React, {memo, useCallback, useState} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {useTranslation} from 'react-i18next';
import {PlusOutlined, DeleteOutlined} from '@ant-design/icons';
import {List, Card, Row, Col} from 'antd';
import styles from './index.less';
import UploadImage from './UploadImage';
import {useCrudImagesQuestionnaire} from '@/modules/templates/hooks/useQuestionnaire';

const QuestionnairePicturesWall = ({
  translation,
  questionnaire,
  disabled
}) => {
  const {t} = useTranslation(translation);

  const [fileList, setFileList] = useState(questionnaire?.images || []);
  const {create} = useCrudImagesQuestionnaire();

  /** On Submit form */
  const onSubmit = useCallback(async (newEvidences) => {
    setFileList(newEvidences);
    const values = {
      questionnaireId: questionnaire?._id,
      images: newEvidences
    };
      // await update({questionId: question?._id, sectionId, ...question, issues});
    await create(values);
  }, [create, questionnaire?._id]);

  /** On remove evidence */
  const onRemove = useCallback(async (idx) => {
    const newEvidences = [...fileList];
    newEvidences?.splice(idx, 1);
    await onSubmit(newEvidences);
  },[fileList, onSubmit]);

  const onRemoveImage= useCallback(async (file) => {
    const newEvidences = fileList?.map(el => el?._id === file?._id ? {...file, url: null} : el);
    await onSubmit(newEvidences);
  },[fileList, onSubmit]);

  /** Add new evidence to the array */
  const onAddEvidence = useCallback(async (e) => {
    e.stopPropagation();
    const newEvidences = fileList?.length ?
      [...fileList, { type: 'photo' }] :
      [{ type: 'photo' }];
    setFileList(newEvidences);
  }, [fileList]);

  /** On Upload image */
  const onUpload = useCallback(async (data, idx) => {
    const newFileList = fileList;
    newFileList[idx] = {...newFileList[idx], url: data?.image, pdfThumb: data?.pdfThumb};
    await onSubmit(newFileList);
  }, [fileList, onSubmit]);

  return (
    <div className={styles.wrapperPictures}>
      <Card
        className={'mb-2 rounded'}
        bodyStyle={{padding: '6px', background: '#FAFAFA'}}
      >
        <div className="font-bold my-2">{t('questionnaireIE.images')}:</div>
        {fileList?.length > 0 && <List itemLayout="vertical"
          size="large"
          pagination={false}
          dataSource={fileList}
          actions={[<div key="1">{'action'}</div>,]}
          renderItem={(file, idx) => (
            <Row key={file?._id} gutter={8}>
              <Col span={22}>
                <Card
                  className={'mb-2 rounded'}
                  bodyStyle={{padding: '6px'}}
                >
                  <Row gutter={8} className="justify-center justify-items-center">
                    <Col flex="130px">
                      <UploadImage
                        value={file}
                        onChange={(data) => onUpload(data, idx)}
                        onRemove={() => onRemoveImage(file)}
                        disabled={disabled}
                        onlyImage={true}
                      />
                    </Col>
                  </Row>
                </Card>
              </Col>
              <Col span={2} className={'m-auto'}>
                <DeleteOutlined style={{color: 'red'}} onClick={() => onRemove(idx)}/>
              </Col>
            </Row>
          )}
        />}
      </Card>
      <div
        onClick={(e) => !disabled && onAddEvidence(e)}
        className={classNames(styles.uploadPictureButton, disabled && 'opacity-50 cursor-not-allowed')}
      >
        <PlusOutlined />
        <div style={{ marginTop: 8 }}>{t('questionnaireIE.addImage')}</div>
      </div>
    </div>
  );
};

QuestionnairePicturesWall.propTypes = {
  translation: PropTypes.string,
  questionnaire: PropTypes.object,
  disabled: PropTypes.bool
};

export default memo(QuestionnairePicturesWall);
